import React, { useEffect, useState } from 'react';
import { MDBBtn, MDBChip, MDBCol, MDBAlert, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow, MDBTimepicker } from 'mdb-react-ui-kit';
import { CreateSchedule, getCancellationPolicy, getStaffInfo, getClass } from '../../services/classApiServices.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import {
    isEmail,
    isEmpty,
} from "../../validators/helper.js";

const CreateEvent = (props) => {
    const [error2, setError2] = useState("")

    const [formData, setFormData] = useState({
        trainerid: "",
        classid: "",
        startdate: props.selectedDate != null ? new Date(props.selectedDate) : new Date(),
        enddate: new Date(),
        timeslots: props.scheduleinfo
            ? (props.scheduleinfo.timeslots || [props.scheduleinfo.timeslot].filter(Boolean))
            : [],
        location: "",
        cancellationpolicyid: "",
        bid: "",
        _id: -1,
        isprivate: false,
        onetime: true,
        recurrence: {
            recurrencetype: "",
            value: [],
            subvalue: []
        },

        recurrenceid: null,
        schedulerange: (() => {
            const today = new Date();
            const futureDate = new Date(today);
            futureDate.setDate(today.getDate() + 30);
            return futureDate;
        })()
    });
    const [visibledaysbefore, setVisibleDaysBefore] = useState();

    let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;
    const classLimit = plansInfo != null ? plansInfo?.limitation?.classbook : -1;
    let expirydate = new Date();
    if (plansInfo != null) {
        if (plansInfo?.planUsage?.expiryDate) {
            expirydate = new Date(plansInfo.planUsage.expiryDate);
        }
        if (plansInfo?.planUsage?.lifetimefree) {
            expirydate.setFullYear(expirydate.getFullYear() + 5);
        }
    }

    const [classes, setClasses] = useState([])
    const [policyData, setPolicyData] = useState([])
    const [trainerData, setTrainerData] = useState([])
    const [recurrence, setRecurrence] = useState("");
    const [selectedDays, setSelectedDays] = useState([]);
    const [selectedWeek, setSelectedWeek] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState([]);
    const [alertModal, setAlertModal] = useState(false);
    const toggleAlertModal = () => setAlertModal(!alertModal);
    const [error, setError] = useState(null);

    const weekOptions = [
        { value: 1, name: "1st" },
        { value: 2, name: "2nd" },
        { value: 3, name: "3rd" },
        { value: 4, name: "4th" },
        { value: 5, name: "5th" }
    ];

    const daysOfWeek = [
        { value: 0, name: "Sun" },
        { value: 1, name: "Mon" },
        { value: 2, name: "Tue" },
        { value: 3, name: "Wed" },
        { value: 4, name: "Thu" },
        { value: 5, name: "Fri" },
        { value: 6, name: "Sat" }
    ];

    const monthsOfYear = [
        { value: 1, name: "Jan" },
        { value: 2, name: "Feb" },
        { value: 3, name: "Mar" },
        { value: 4, name: "Apr" },
        { value: 5, name: "May" },
        { value: 6, name: "Jun" },
        { value: 7, name: "Jul" },
        { value: 8, name: "Aug" },
        { value: 9, name: "Sep" },
        { value: 10, name: "Oct" },
        { value: 11, name: "Nov" },
        { value: 12, name: "Dec" }
    ];

    const [timeSlot, setTimeSlot] = useState("");


    useEffect(() => {
        if (!props.scheduleinfo) return;

        console.log(props.scheduleinfo, '777777777777777');

        if (!props.scheduleinfo) return;

        let timeslotsArray = [];

        // For update mode, ensure we always have exactly one time slot
        if (props.scheduleinfo.timeslots && props.scheduleinfo.timeslots.length > 0) {
            // Use the first time slot if multiple exist (shouldn't happen in update)
            timeslotsArray = [props.scheduleinfo.timeslots[0]];
        } else if (props.scheduleinfo.timeslot) {
            // Old structure with single timeslot string
            timeslotsArray = [props.scheduleinfo.timeslot];
        } else {
            // Fallback to empty array
            timeslotsArray = [''];
        }

        // Set the timeSlot state to the first (and only) slot
        setTimeSlot(timeslotsArray[0] || '');

        const updatedFormData = {
            ...props.scheduleinfo,
            startdate: props.scheduleinfo.startdate ? new Date(props.scheduleinfo.startdate) : new Date(),
            enddate: props.scheduleinfo.enddate ? new Date(props.scheduleinfo.enddate) : new Date(),
            schedulerange: props.scheduleinfo.schedulerange
                ? new Date(props.scheduleinfo.schedulerange)
                : new Date(),

            timeslots: timeslotsArray

        };

        setFormData(updatedFormData)

        const rangeValue = parseInt(props.scheduleinfo.visibledaysbefore);
        if (!isNaN(rangeValue) && rangeValue > 0) {
            setVisibleDaysBefore(rangeValue);
        } else {
            setVisibleDaysBefore(10);
        }


    }, [props.scheduleinfo]);

    useEffect(() => {

        const fetchData = async () => {
            const response = await getClass(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response || response === "false") {
                return;
            }
            const classinfo = await response.json();

            console.log(classinfo, 'classsssssssss');
            setClasses(classinfo)
            // setRefresh(false)
        }
        const fetchpolicy = async () => {
            const res = await getCancellationPolicy(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!res || res === "false") {
                return;
            }
            const policyinfo = await res.json();

            console.log(policyinfo, 'Policyinfo');
            setPolicyData(policyinfo)
        }
        const fetchclassData = async () => {

            const trainerres = await getStaffInfo(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!trainerres || trainerres === "false") {
                return;
            }
            const trainerinfo = await trainerres.json();

            console.log(trainerinfo, 'trainerinfo');
            setTrainerData(trainerinfo)
            // setRefresh(false)
        }
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData()
            fetchpolicy()
            fetchclassData()
        }


    }, [])

    const toggleRecuring = (item) => {
        setFormData((prevState) => {
            let updatedValues = [...prevState.recurrence.value];

            // If clicking "All Days" (-1)
            if (item === -1) {
                if (updatedValues.includes(-1)) {
                    // If "All Days" is already selected, deselect everything
                    updatedValues = [];
                } else {
                    // Select "All Days" and all individual days (0-6)
                    updatedValues = [-1, 0, 1, 2, 3, 4, 5, 6];
                }
            }
            // If clicking an individual day
            else {
                if (updatedValues.includes(item)) {
                    // Remove the day
                    updatedValues = updatedValues.filter(value => value !== item);
                    // Also remove "All Days" if it's selected
                    const allDaysIndex = updatedValues.indexOf(-1);
                    if (allDaysIndex !== -1) {
                        updatedValues.splice(allDaysIndex, 1);
                    }
                } else {
                    // Add the day
                    updatedValues.push(item);
                    // Remove "All Days" if it's selected
                    const allDaysIndex = updatedValues.indexOf(-1);
                    if (allDaysIndex !== -1) {
                        updatedValues.splice(allDaysIndex, 1);
                    }

                    // Check if all days are now selected (0-6)
                    const allIndividualDays = [0, 1, 2, 3, 4, 5, 6];
                    const hasAllDays = allIndividualDays.every(day =>
                        updatedValues.includes(day)
                    );

                    // If all individual days are selected, add "All Days" marker
                    if (hasAllDays) {
                        updatedValues.push(-1);
                    }
                }
            }

            return {
                ...prevState,
                recurrence: {
                    ...prevState.recurrence,
                    value: updatedValues
                }
            };
        });
    };



    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "recurrence") {
            setFormData((prevState) => ({
                ...prevState,
                recurrence: {
                    ...(prevState.recurrence || {}),
                    recurrencetype: value,
                    value: []
                }
            }));
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }

        setError((prevErrors) => {
            if (!prevErrors || !prevErrors[name]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });
        if (name === "classid") {

            const selectedClass = classes?.find(cls => cls._id === value) || null;
            setFormData((prevState) => ({
                ...prevState,
                "totalslots": parseInt(selectedClass.slots, 10)
            }));
        }
    };


    // Handle change for checkboxes
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: !checked
        }));

        if (checked) {
            setRecurrence('')
        }
    };
    const handleTimeChange = (selectedTime) => {
        console.log(selectedTime);

        const timeFormatRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s(AM|PM)$/;

        if (typeof selectedTime === 'string') {
            if (timeFormatRegex.test(selectedTime)) {
                if (props.scheduleinfo) {
                    // Update mode - single time slot
                    const updatedTimeSlots = [selectedTime];
                    setFormData(prevState => ({
                        ...prevState,
                        timeslots: updatedTimeSlots
                    }));
                } else {
                    // Create mode - just update the timeSlot state
                    setTimeSlot(selectedTime);
                }

                // Clear timeslots error by removing the key from error object
                setError(prev => {
                    if (!prev) return null;
                    const newErrors = { ...prev };
                    delete newErrors.timeslots;
                    return Object.keys(newErrors).length === 0 ? null : newErrors;
                });
            } else {
                // Invalid time format - clear timeSlot and set error
                if (!props.scheduleinfo) {
                    setTimeSlot("");
                }
                setError(prev => ({
                    ...(prev || {}),
                    timeslots: "Please select a valid time (e.g., 07:30 PM)."
                }));
            }
        }
    };

    const addTimeSlot = () => {
        const timeFormatRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s(AM|PM)$/;

        if (!timeSlot || timeSlot.trim() === "") {
            setError(prev => ({
                ...(prev || {}),
                timeslots: "Please select a valid time"
            }));
            return;
        }

        if (typeof timeSlot !== 'string' || !timeFormatRegex.test(timeSlot)) {
            setError(prev => ({
                ...(prev || {}),
                timeslots: "Please select a valid time (e.g., 07:30 PM)."
            }));
            return;
        }

        // Check for duplicate times
        if (formData.timeslots.includes(timeSlot)) {
            setError(prev => ({
                ...(prev || {}),
                timeslots: "This time slot already exists"
            }));
            return;
        }

        setFormData(prev => ({
            ...prev,
            timeslots: [...prev.timeslots, timeSlot]
        }));
        setTimeSlot("");

        // Clear timeslots error by removing the key from error object
        setError(prev => {
            if (!prev) return null;
            const newErrors = { ...prev };
            delete newErrors.timeslots;
            return Object.keys(newErrors).length === 0 ? null : newErrors;
        });
    };

    const removeTimeSlot = (index) => {
        setFormData(prev => {
            const newTimeslots = prev.timeslots.filter((_, i) => i !== index);

            // Clear timeSlot state as well
            setTimeSlot("");

            // Check if AFTER removal, we have no time slots
            if (newTimeslots.length === 0) {
                // Set error for empty time slots
                setError(prevError => ({
                    ...(prevError || {}),
                    timeslots: "Please add at least one time slot"
                }));
            } else {
                // We still have time slots, so clear any "add at least one" error
                setError(prevError => {
                    if (!prevError) return null;
                    const newErrors = { ...prevError };
                    // Only clear if it's the "add at least one" error
                    if (newErrors.timeslots === "Please add at least one time slot") {
                        delete newErrors.timeslots;
                    }
                    return Object.keys(newErrors).length === 0 ? null : newErrors;
                });
            }

            return {
                ...prev,
                timeslots: newTimeslots
            };
        });
    };


    console.log(formData, "000")
    // Handle change for date inputs
    const handleDateChange = (name, value) => {
        console.log(name, value);
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

    };

    let validateForm = (e) => {

        let errors = {};

        if (isEmpty(formData.classid)) {
            errors.classid = "Please select a Class";
        }

        if (isEmpty(formData.trainerid)) {
            errors.trainerid = "Please select a Trainer";
        }
        if (formData.timeslots.length === 0) {
            errors.timeslots = "Please add at least one time slot";
        }

        if (isEmpty(formData.location)) {
            errors.location = "Location can't be blank";
        }
        //  else if (!isEmpty(formData.lastname) && !isAlphabetical(formData.lastname)) {
        //     errors.lastname = "Name can be only Alhabets  ";
        // }
        // if (isEmpty(formData.cancellationpolicyid)) {
        //     errors.cancellationpolicyid = "Please select a Policy";
        // }

        if (!visibledaysbefore || visibledaysbefore.toString().trim() === "") {
            errors.visibledaysbefore = "Days can't be blank";
        }


        if (!formData.onetime) {
            const scheduleDate = new Date(formData.schedulerange);
            const startDate = new Date(formData.startdate);

            if (isNaN(scheduleDate.getTime())) {
                errors.schedulerange = "Please select a schedule end date";
            } else {
                const scheduleDateOnly = new Date(scheduleDate.setHours(0, 0, 0, 0));
                const startDateOnly = new Date(startDate.setHours(0, 0, 0, 0));

                // if (scheduleDateOnly <= startDateOnly) {
                //     errors.schedulerange = "Select a schedule date (up to the allowed limit)";
                // }
            }

            if (!formData.recurrence || isEmpty(formData.recurrence.recurrencetype)) {
                errors.recurrencetype = "Please select a Recurrence";
            }
            const recurrenceType = formData?.recurrence?.recurrencetype;

            // In the validateForm function, update the monthly validation section
            if (recurrenceType === "monthly") {
                const weeks = Array.isArray(formData.recurrence.value) ? formData.recurrence.value : [];
                const weekdays = Array.isArray(formData.recurrence.subvalue) ? formData.recurrence.subvalue : [];

                // Check if "All Weeks" is selected (-1) or at least one valid week (1-5)
                const hasAllWeeks = weeks.includes(-1);
                const hasValidWeeks = weeks.some(w => w !== -1 && w !== "-1");
                const validWeeks = hasAllWeeks || hasValidWeeks;

                // Check if "All Days" is selected (-1) or at least one valid day (0-6)
                const hasAllDays = weekdays.includes(-1);
                const hasValidDays = weekdays.some(d => d !== -1 && d !== "-1");
                const validDays = hasAllDays || hasValidDays;

                if (!validWeeks) {
                    errors.recurrencevalue = "Please select at least one Week";
                }

                if (!validDays) {
                    errors.recurrencedays = "Please select at least one Weekday";
                }
            }



            if (recurrenceType === "weekly" || recurrenceType === "daily") {
                const weekdays = Array.isArray(formData.recurrence.value)
                    ? formData.recurrence.value
                    : [];
                const normalizedDays = weekdays.map(String);

                const validWeekdays = normalizedDays.length > 0;

                if (!validWeekdays) {
                    errors.recurrencevalue = "Please select at least one Day";
                }
            }
        }

        console.log(errors);
        if (isEmpty(errors)) {
            setError({});
            return true;
        } else {
            return errors;
        }
    };


    useEffect(() => {
        if (formData.recurrence?.recurrencetype) {
            setError(prev => {
                const newErrors = { ...prev };
                delete newErrors.recurrencetype;
                // clear errors dynamically based on values
                if (formData.recurrence.recurrencetype === "monthly") {
                    if (formData.recurrence.value?.length > 0) {
                        delete newErrors.recurrencevalue;
                    }
                    if (formData.recurrence.subvalue?.length > 0) {
                        delete newErrors.recurrencedays;
                    }
                }
                if (
                    (formData.recurrence.recurrencetype === "weekly" ||
                        formData.recurrence.recurrencetype === "daily") &&
                    formData.recurrence.value?.length > 0
                ) {
                    delete newErrors.recurrencevalue;
                }

                return newErrors;
            });
        }
    }, [formData.recurrence?.recurrencetype, formData.recurrence?.value, formData.recurrence?.subvalue]);



    console.log(error, 'error');

    const handleSubmit = async (e, applied) => {
        e.preventDefault();

        try {
            let errors = validateForm();
            if (errors == true) {

                const gymid = localStorage.getItem("loggedUserInfo")
                    ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                    : -1;

                const selectedClass = classes?.find(
                    cls => cls._id === formData.classid
                ) || null;

                const startDateString = formData.startdate instanceof Date
                    ? moment(formData.startdate).format("YYYY-MM-DD")
                    : formData.startdate;

                for (let slot of formData.timeslots) {

                    const timeFormat =
                        slot.includes("AM") || slot.includes("PM")
                            ? "hh:mm A"
                            : "HH:mm";

                    const startDateTime = moment.tz(
                        `${startDateString} ${slot}`,
                        `YYYY-MM-DD ${timeFormat}`,
                        "Asia/Kolkata"
                    );

                    if (!startDateTime.isValid()) {
                        console.error("Invalid startDateTime:", startDateTime);
                        return;
                    }

                    const endDateTime = selectedClass
                        ? startDateTime.clone().add(
                            parseInt(selectedClass.duration, 10),
                            "minutes"
                        )
                        : moment.tz(
                            formData.enddate,
                            "YYYY-MM-DD HH:mm",
                            "Asia/Kolkata"
                        );

                    console.log(startDateTime, endDateTime, "startDateTime");

                    const scheduleRangeMoment =
                        formData.schedulerange instanceof Date
                            ? moment(formData.schedulerange).toISOString()
                            : formData.schedulerange;

                    const update = {
                        trainerid: formData.trainerid,
                        classid: formData.classid,
                        startdate: startDateTime.toISOString(),
                        enddate: endDateTime.toISOString(),
                        timeslot: slot,
                        location: formData.location,
                        cancellationpolicyid: formData.cancellationpolicyid,
                        bid: gymid,
                        _id: formData._id ? formData._id : -1,
                        isprivate: formData.isprivate,
                        onetime: formData.onetime,
                        recurrence: !formData.onetime ? formData.recurrence : null,
                        isapplyall: applied ? applied : null,
                        recurrenceid: formData.recurrenceid,
                        totalslots: formData?.totalslots
                            ? formData?.totalslots
                            : parseInt(selectedClass.slots, 10),
                        montlylimit: classLimit,
                        subscriptionexpirydate: expirydate,
                        schedulerange: scheduleRangeMoment,
                        visibledaysbefore: visibledaysbefore
                    };

                    console.log("updateupdate", update);

                    const response = await CreateSchedule(gymid, update);
                    const resp = await response.json();

                    if (!resp.message) {
                        if (resp.status == 202) {
                            setError2(
                                `You have reached your schedule limit for ${resp.monthName}. Please upgrade your plan to add more schedules.`
                            );
                            return;
                        } else if (resp.status == 203) {
                            setError2(
                                "Your subscription will expire before the selected schedule date. Please upgrade or renew your plan to continue."
                            );
                            return;
                        } else {
                            setError2(
                                "Something went wrong while creating the schedule. Please try again later."
                            );
                            return;
                        }
                    }
                }


                props.onSave();

            } else {
                setError(errors);
            }

        } catch (error) {
            console.error("Error:", error);
        }
    };


    console.log(formData);

    const handleApplyToAll = (e) => {
        // setIsapplied(true)
        setAlertModal(false)
        handleSubmit(e, true)
    }
    const handleCancel = (e) => {
        setAlertModal(false)
    }

    const handleApplyToOne = (e) => {
        setAlertModal(false)
        handleSubmit(e, false)
    }





    return (
        <div>
            <MDBModalHeader>
                <MDBModalTitle>{props.scheduleinfo ? "Update Schedule" : "Add New Schedule"}</MDBModalTitle>
                <MDBBtn className="btn-close" color="none" onClick={props.onclose}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
                <MDBRow className="mt-2">
                    <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                        <label htmlFor="" className="fw-bold mb-2">Class</label>
                        <select
                            className="form-select"
                            name="classid"
                            value={formData.classid} onChange={handleChange}
                        >
                            <option value="">Select a class</option>
                            {classes && classes.length > 0
                                ? classes.map((item) => (
                                    <option key={item._id} value={item._id}>
                                        {item.name}
                                    </option>
                                ))
                                : null
                            }
                        </select>
                        {error?.classid && (
                            <>
                                <p className="clr-red">{error?.classid}</p>
                            </>
                        )}
                    </MDBCol>

                    <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                        <label htmlFor="" className="fw-bold mb-2">Trainer</label>
                        <select className="form-select" name="trainerid" value={formData.trainerid} onChange={handleChange}>
                            <option value="">Select a Trainer</option>
                            {trainerData && trainerData.length > 0
                                ? trainerData.map((item) => (
                                    <option key={item._id} value={item._id}>
                                        {item.firstname + " " + item.lastname}
                                    </option>
                                ))
                                : null
                            }

                        </select>
                        {error?.trainerid && (
                            <>
                                <p className="clr-red">{error?.trainerid}</p>
                            </>
                        )}
                    </MDBCol>

                    <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                        <label htmlFor="" className="fw-bold mb-2">Start Date</label>
                        <DatePicker
                            className="form-control"
                            selected={formData.startdate ? new Date(formData.startdate) : null}
                            dateFormat="MM-dd-yyyy"
                            onChange={(date) => handleDateChange('startdate', date)}
                            minDate={new Date()}
                            maxDate={new Date(expirydate)}
                        />
                    </MDBCol>


                    <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                        <label htmlFor="" className="fw-bold mb-2">Time Slots</label>

                        {props.scheduleinfo ? (

                            <div>
                                {/* Show current time slot in time picker */}
                                <MDBTimepicker
                                    inline
                                    label=""
                                    value={timeSlot}
                                    onChange={handleTimeChange}

                                />

                                {/* Show the single time slot badge */}
                                <div className="mt-2">
                                    {formData.timeslots && formData.timeslots.length > 0 && (
                                        <div className="badge bg-primary p-2">
                                            {formData.timeslots[0]}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            /* CREATE MODE - Allow multiple time slots */
                            <div>
                                <div className="d-flex mb-2">
                                    <MDBTimepicker
                                        inline
                                        label=""
                                        value={timeSlot}
                                        onChange={handleTimeChange}
                                    />
                                    <MDBBtn
                                        color="primary"
                                        size="sm"
                                        className="ms-2"
                                        onClick={addTimeSlot}
                                    >
                                        Add
                                    </MDBBtn>
                                </div>

                                {/* Show all time slot badges with remove option */}
                                <div className="d-flex flex-wrap gap-2">
                                    {formData?.timeslots && formData?.timeslots.map((slot, index) => (
                                        <div key={index} className="badge bg-primary d-flex align-items-center p-2">
                                            {slot}
                                            <button
                                                type="button"
                                                className="btn-close btn-close-white ms-2"
                                                onClick={() => removeTimeSlot(index)}
                                                aria-label="Remove"
                                                style={{ fontSize: '0.5rem' }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Show error message */}
                        {error?.timeslots && (
                            <p className="clr-red mt-2">{error.timeslots}</p>
                        )}
                    </MDBCol>

                    <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                        <label htmlFor="" className="fw-bold mb-2">Location</label>
                        <MDBInput placeholder="Enter Location" name="location" value={formData.location} onChange={handleChange} />
                        {error?.location && (
                            <>
                                <p className="clr-red">{error?.location}</p>
                            </>
                        )}
                    </MDBCol>


                    <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                        <label htmlFor="" className="fw-bold mb-2">Cancellation Policy</label>
                        <select className="form-select" name="cancellationpolicyid" value={formData.cancellationpolicyid} onChange={handleChange}>
                            <option value="">Select Policy</option>
                            {policyData && policyData.length > 0
                                ? policyData.map((item) => (
                                    <option key={item._id} value={item._id}>
                                        {item.name}
                                    </option>
                                ))
                                : null
                            }
                        </select>
                        {error?.cancellationpolicyid && (
                            <>
                                <p className="clr-red">{error?.cancellationpolicyid}</p>
                            </>
                        )}
                    </MDBCol>
                    <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                        <label htmlFor="" className="fw-bold mb-2">Total Slots</label>
                        <MDBInput placeholder="Enter totalslots" name="totalslots" value={formData.totalslots} onChange={handleChange} />
                        {error?.totalslots && (
                            <>
                                <p className="clr-red">{error?.totalslots}</p>
                            </>
                        )}
                    </MDBCol>
                    <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                        <label htmlFor="visibledaysbeforeInput" className="fw-bold mb-2 d-block">
                            Show Before (Days)
                        </label>
                        <div className="input-group">
                            <MDBInput
                                id="visibledaysbeforeInput"
                                type="number"
                                value={visibledaysbefore || ""}
                                aria-label="Days before event to start showing it"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setError((prevErrors) => {
                                        if (!prevErrors || !prevErrors.visibledaysbefore) return prevErrors;
                                        const updatedErrors = { ...prevErrors };
                                        delete updatedErrors.visibledaysbefore;
                                        return updatedErrors;
                                    });

                                    if (value === "") {
                                        setVisibleDaysBefore("");
                                        return;
                                    }

                                    if (/^\d{1,4}$/.test(value)) {
                                        const parsed = parseInt(value, 10);
                                        if (parsed > 0) {
                                            setVisibleDaysBefore(parsed);
                                        } else {
                                            setVisibleDaysBefore("");
                                        }
                                    }
                                }}
                            />
                            <span className="input-group-text">days</span>
                        </div>
                        <p className="text-muted m-0">
                            Show upcoming events on the calendar from the start date (e.g., 2–3 days before).
                        </p>

                        {error?.visibledaysbefore && (
                            <p className="clr-red">
                                {error?.visibledaysbefore}
                            </p>
                        )}
                    </MDBCol>

                    <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                        <div className=' h-100'>
                            <label htmlFor="visibledaysbeforeInput" className="fw-bold mb-2 d-block">
                                One Time
                            </label>
                            <div className='d-flex align-items-center py-1'>
                                <label className="switch">
                                    <input className="form-control" type="checkbox" name="onetime" checked={!formData.onetime} onChange={handleCheckboxChange} />
                                    <span className="slider round"></span>
                                </label>  <label htmlFor="" className='fw-bold ms-2'>
                                    Recurrence
                                </label>

                            </div>
                        </div>
                    </MDBCol>

                    <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                        <div className=' h-100'>
                            <label htmlFor="visibledaysbeforeInput" className="fw-bold mb-2 d-block">
                                Private
                            </label>
                            <div className='d-flex align-items-center py-1'>
                                <label className="switch">
                                    <input className="form-control" type="checkbox" name="isprivate" checked={formData.isprivate}
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            isprivate: !formData.isprivate
                                        })}

                                    />
                                    <span className="slider round"></span>
                                </label>

                            </div>
                        </div>
                    </MDBCol>




                    {!formData.onetime && (
                        <MDBCol sm={12} md={6} lg={6}>
                            <div>
                                <label htmlFor="" className="fw-bold mb-2">
                                    Recurrence
                                </label>
                                <select
                                    className="form-select mb-2"
                                    name="recurrence"
                                    value={formData?.recurrence?.recurrencetype || ""}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Recurrence</option>
                                    {/* <option value="daily">Daily</option> */}
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                </select>
                                {error?.recurrencetype && (
                                    <p className="clr-red">{error?.recurrencetype}</p>
                                )}
                            </div>

                        </MDBCol>
                    )}


                    {!formData.onetime && (
                        <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                            <label htmlFor="" className="fw-bold mb-2">Schedule Range</label>
                            <DatePicker
                                className={`form-control ${error?.schedulerange ? 'is-invalid' : ''}`}
                                selected={formData.schedulerange ? new Date(formData.schedulerange) : null}
                                dateFormat="MM-dd-yyyy"
                                minDate={formData.startdate || new Date()}
                                maxDate={new Date(expirydate)}
                                onChange={(date) => {
                                    handleDateChange('schedulerange', date);
                                    // setError(prev => ({ ...prev, schedulerange: undefined }));
                                }}
                            />
                            <>
                                {error?.schedulerange && (
                                    <div className="clr-red">
                                        {error?.schedulerange}
                                    </div>
                                )}
                            </>

                        </MDBCol>
                    )}



                    {!formData.onetime && (formData.recurrence?.recurrencetype === "weekly" || formData.recurrence?.recurrencetype === "daily") && (
                        <MDBCol sm={12} md={12} className='mb-3'>
                            <div>
                                <label htmlFor="" className='fw-bold mb-2'>
                                    Days
                                </label>
                                <div className='d-flex flex-wrap'>
                                    <MDBChip className={formData.recurrence.value.includes(-1) ? 'activeDay' : ""} onClick={() => toggleRecuring(-1)}>All Days</MDBChip>
                                    {daysOfWeek.map((day) => (
                                        <MDBChip
                                            key={day.value}
                                            className={formData.recurrence.value.includes(day.value) ? 'activeDay' : ""}
                                            onClick={() => toggleRecuring(day.value)}
                                        >
                                            {day.name}
                                        </MDBChip>
                                    ))}
                                </div>
                                {error?.recurrencevalue && (
                                    <>
                                        <p className="clr-red">{error?.recurrencevalue}</p>
                                    </>
                                )}
                            </div>
                        </MDBCol>
                    )}

                    {/* {!formData.onetime && formData.recurrence?.recurrencetype === "weekly" && (
                        <MDBCol className='mb-3'>
                            <div>
                                <label htmlFor="" className='fw-bold mb-2'>
                                    Week
                                </label>
                                <div className='d-flex flex-wrap'>
                                    <MDBChip className={formData.recurrence.value.includes(-1) ? 'activeDay' : ""} onClick={() => toggleRecuring(-1)}>All Weeks</MDBChip>
                                    {weekOptions.map((week) => (
                                        <MDBChip
                                            key={week.value}
                                            className={formData.recurrence.value.includes(week.value) ? 'activeDay' : ''}
                                            onClick={() => toggleRecuring(week.value)}
                                        >
                                            {week.name} Week
                                        </MDBChip>
                                    ))}
                                </div>
                                {error.recurrencevalue && (
                                    <>
                                        <p className="clr-red">{error.recurrencevalue}</p>
                                    </>
                                )}
                            </div>
                        </MDBCol>
                    )} */}



                    {!formData.onetime && formData.recurrence?.recurrencetype === "monthly" && (
                        <>
                            <MDBCol sm={12} md={12} className='mb-3'>
                                <div>
                                    <label htmlFor="" className='fw-bold mb-2'>
                                        Weeks
                                    </label>
                                    <div className='d-flex flex-wrap'>
                                        <MDBChip
                                            className={formData.recurrence.value.includes(-1) ? 'activeDay' : ""}
                                            onClick={() => {
                                                // Get all week values (1-5)
                                                const allWeeks = weekOptions.map(week => week.value);

                                                if (formData.recurrence.value.includes(-1)) {
                                                    // If "All Weeks" is currently selected, deselect everything
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        recurrence: {
                                                            ...prev.recurrence,
                                                            value: []
                                                        }
                                                    }));
                                                } else {
                                                    // If "All Weeks" is not selected, select "All Weeks" AND all individual weeks
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        recurrence: {
                                                            ...prev.recurrence,
                                                            value: [-1, ...allWeeks]
                                                        }
                                                    }));
                                                }
                                            }}
                                        >
                                            All Weeks
                                        </MDBChip>
                                        {weekOptions.map((week) => (
                                            <MDBChip
                                                key={week.value}
                                                className={formData.recurrence.value.includes(week.value) ? 'activeDay' : ''}
                                                onClick={() => {
                                                    let newValue = [...formData.recurrence.value];

                                                    if (newValue.includes(week.value)) {
                                                        // Remove the week
                                                        const index = newValue.indexOf(week.value);
                                                        newValue.splice(index, 1);

                                                        // Remove "All Weeks" if selected
                                                        const allWeeksIndex = newValue.indexOf(-1);
                                                        if (allWeeksIndex !== -1) {
                                                            newValue.splice(allWeeksIndex, 1);
                                                        }
                                                    } else {
                                                        // Add the week
                                                        newValue.push(week.value);

                                                        // Check if all weeks (1-5) are now selected
                                                        const allIndividualWeeks = weekOptions.map(w => w.value);
                                                        const hasAllWeeks = allIndividualWeeks.every(w =>
                                                            newValue.includes(w)
                                                        );

                                                        if (hasAllWeeks) {
                                                            // If all individual weeks are selected, add "All Weeks" marker
                                                            newValue.push(-1);
                                                        }
                                                    }

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        recurrence: {
                                                            ...prev.recurrence,
                                                            value: newValue
                                                        }
                                                    }));
                                                }}
                                            >
                                                {week.name} Week
                                            </MDBChip>
                                        ))}
                                        {error?.recurrencevalue && (
                                            <p className="clr-red">{error?.recurrencevalue}</p>
                                        )}
                                    </div>
                                </div>
                            </MDBCol>

                            <MDBCol md="12" className='mb-3'>
                                <div>
                                    <label htmlFor="" className='fw-bold mb-2'>
                                        Days
                                    </label>
                                    <div className='d-flex flex-wrap'>
                                        <MDBChip
                                            className={formData?.recurrence?.subvalue?.includes(-1) ? 'activeDay' : ""}
                                            onClick={() => {
                                                // Get all day values (0-6)
                                                const allDays = daysOfWeek.map(day => day.value);

                                                if (formData?.recurrence?.subvalue?.includes(-1)) {
                                                    // If "All Days" is currently selected, deselect everything
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        recurrence: {
                                                            ...prev.recurrence,
                                                            subvalue: []
                                                        }
                                                    }));
                                                } else {
                                                    // If "All Days" is not selected, select "All Days" AND all individual days
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        recurrence: {
                                                            ...prev.recurrence,
                                                            subvalue: [-1, ...allDays]
                                                        }
                                                    }));
                                                }
                                            }}
                                        >
                                            All Days
                                        </MDBChip>
                                        {daysOfWeek.map((day) => (
                                            <MDBChip
                                                key={day.value}
                                                className={formData.recurrence?.subvalue?.includes(day.value) ? 'activeDay' : ''}
                                                onClick={() => {
                                                    let newSubvalue = [...formData.recurrence?.subvalue];

                                                    if (newSubvalue.includes(day.value)) {
                                                        // Remove the day
                                                        const index = newSubvalue.indexOf(day.value);
                                                        newSubvalue.splice(index, 1);

                                                        // Remove "All Days" if selected
                                                        const allDaysIndex = newSubvalue.indexOf(-1);
                                                        if (allDaysIndex !== -1) {
                                                            newSubvalue.splice(allDaysIndex, 1);
                                                        }
                                                    } else {
                                                        // Add the day
                                                        newSubvalue.push(day.value);

                                                        // Check if all days (0-6) are now selected
                                                        const allIndividualDays = daysOfWeek.map(d => d.value);
                                                        const hasAllDays = allIndividualDays.every(d =>
                                                            newSubvalue.includes(d)
                                                        );

                                                        if (hasAllDays) {
                                                            // If all individual days are selected, add "All Days" marker
                                                            newSubvalue.push(-1);
                                                        }
                                                    }

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        recurrence: {
                                                            ...prev.recurrence,
                                                            subvalue: newSubvalue
                                                        }
                                                    }));
                                                }}
                                            >
                                                {day.name}
                                            </MDBChip>
                                        ))}
                                    </div>
                                    {error?.recurrencedays && (
                                        <p className="clr-red">{error?.recurrencedays}</p>
                                    )}
                                </div>
                            </MDBCol>
                        </>
                    )}

                </MDBRow>
            </MDBModalBody >
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onclose}>Close</MDBBtn>
                {/* <MDBBtn color="primary" disabled={error != null} onClick={(formData._id !== -1 && !formData.onetime) ? toggleAlertModal : handleSubmit}>{props.scheduleinfo ? "Update" : "Save"}</MDBBtn> */}
                <MDBBtn
                    color="primary"
                    disabled={Object.keys(error || {}).length > 0}
                    onClick={(formData._id !== -1 && !formData.onetime) ? toggleAlertModal : handleSubmit}
                >
                    {props.scheduleinfo ? "Update" : "Save"}
                </MDBBtn>

            </MDBModalFooter>


            <MDBModal tabIndex="-1" open={alertModal} onClose={toggleAlertModal}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Confirm Changes</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={toggleAlertModal}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>Do you want to apply these changes to all recurring events or only this event?</p>
                        </MDBModalBody>
                        <MDBModalFooter className='pe-2 pb-2'>
                            <MDBBtn color="secondary" onClick={handleCancel}>
                                Cancel
                            </MDBBtn>
                            <MDBBtn color="primary" onClick={handleApplyToAll}>
                                Apply to All Recurring Events
                            </MDBBtn>
                            <MDBBtn color="primary" onClick={handleApplyToOne}>
                                Apply Only to This Event
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            {/* handleApplyToAll handleApplyToOne */}
            <MDBAlert
                color={(error2.includes('success') ? 'success' : 'danger')}
                autohide
                position='top-right'
                delay={5000}
                appendToBody
                open={error2 != ""}
                onClose={() => setError2("")}
            >
                {error2}
            </MDBAlert>
        </div >
    );
};

export default CreateEvent;
